import { Marker } from 'mapbox-gl';
import { createMarkerPin } from './markerPin';

export default class mapMarker {
  #marker
  #pinElement

  constructor(data, map) {
    this.#pinElement = createMarkerPin();
    this.#marker = this.createMapboxMarker(data, map);
  }

  on(event = 'click', fn) {
    this.#marker.getElement().addEventListener(event, e => fn(e));
  }

  removeHighlight() {
    // eslint-disable-next-line no-underscore-dangle
    const transform = `translate(-50%, -50%) translate(${this.#marker._pos.x}px, ${this.#marker._pos.y}px)`;
    Object.assign(this.#pinElement.style, { transform });
  }

  highlight() {
    // eslint-disable-next-line no-underscore-dangle
    const transform = `translate(-50%, -50%) translate(${this.#marker._pos.x}px, ${this.#marker._pos.y}px) scale(1.4)`;
    Object.assign(this.#pinElement.style, { transform });
  }

  getMarker() {
    return this.#marker;
  }

  createMapboxMarker({ latitude, longitude }, map = undefined) {
    return new Marker({
      element: this.#pinElement,
      // offset: [11, 34] , // offset to match icon grpahic, if needed
    })
      .setLngLat([longitude, latitude])
      .addTo(map);
  }
}
